import { render, staticRenderFns } from "./floor_point.vue?vue&type=template&id=65b2ef73&lang=pug&"
import script from "./floor_point.vue?vue&type=script&lang=js&"
export * from "./floor_point.vue?vue&type=script&lang=js&"
import style0 from "./floor_point.vue?vue&type=style&index=0&id=65b2ef73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports